import React, { useEffect, useState,useRef } from "react";
// COMPONENT
import Draggable from 'react-draggable';
import Footer from '../../components/footer';
import HeaderMenu from '../../components/headermenu';
import OrganizerProfile from '../../component/organizer/organizerprofile';
import MobileMenu from '../../components/mobilemenu';
import CoundownDiv from '../../component/coundown';
import DOMPurify from 'dompurify';
import moment from 'moment';
import { FaTimes } from 'react-icons/fa';
import { apiurl, onlyDayMonth, shortPer, app_url, getDayName, getDay, getMonthName, get_min_date, laravel_asset, eventnameurl } from "../../common/Helpers";
import { useNavigate, Link } from "react-router-dom";
import Nouserphoto from '../../common/image/nouser.png';
import locationIcon from "../../assets/location (5) 1.svg";
import Container from "react-bootstrap/Container";
import { useParams } from 'react-router-dom';
import { FaWhatsapp } from "react-icons/fa";
import { FaFacebookF } from "react-icons/fa";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Noimg from "../../common/image/noimg.jpg";
import calendar from "../../assets/calendar.svg";
import { GoogleMap, Marker } from '@react-google-maps/api';
import { Modal, ModalHeader, ModalBody, Tooltip } from 'reactstrap';
import WhiteShareIcon from "../../common/icon/whiteshear.svg";
import EventImg from "../../common/event1.png";
import Flip from "react-reveal/Flip";
import Fade from "react-reveal/Fade";
import Slide from "react-reveal/Slide";
import toast from "react-hot-toast";
import locationIconevent from "./eventpageicon/Location (8).svg";
import hourglassIcon from "./eventpageicon/hourglass.svg";
import timeIcon from "./eventpageicon/clock.svg";
import dataIcon from "./eventpageicon/date 2.svg";
import { FaRegHeart } from "react-icons/fa6";
import { FaHeart } from "react-icons/fa6";
import { Helmet } from 'react-helmet';
const Home = ({ ispreview }) => {
  const navigate = useNavigate();
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const Beartoken = localStorage.getItem('userauth');
  const { id, name } = useParams();
  const [Apiloader, setApiloader] = useState(true);

  const [seatmapModal, setseatmapModal] = useState(false);
  const [seatmapHeight, setSeatmapHeight] = useState();
  const [seatmapWidth, setSeatmapWidth] = useState();
  const [image, setImage] = useState(null);
  const [sections, setSections] = useState([]);
  const [ColorSeat, setColorSeat] = useState([]);
  const [tooltipOpen, setTooltipOpen] = useState(null);
  const [selectedSeats, setSelectedSeats] = useState([]);
  const [SeatHistorylog, setSeatHistorylog] = useState([]);
  const [checkitemid, setcheckitemid] = useState([]);

  const [FollowApi, setFollowApi] = useState(false);
  const [Eventsaveapi, setEventsaveapi] = useState(true);
  const [isFirstRender, setIsFirstRender] = useState(false);
  const [Eventdata, setEventdata] = useState();
  const [TicketsList, setTicketsList] = useState([]);
  const [TicketsSelledList, setTicketsSelledList] = useState([]);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [SelectedTicketId, setSelectedTicketId] = useState(null);
  const [Followtype, setFollowtype] = useState(false);
  const [IssaveEvent, setIssaveEvent] = useState(false);
  const [Iscopy, setIscopy] = useState(false);
  const [Followtypeloader, setFollowtypeloader] = useState(false);
  const [Organizerdata, setOrganizerdata] = useState();
  const [currentUrl, setCurrentUrl] = useState(window.location.href);
  const [Paynowbtnstatus, setPaynowbtnstatus] = useState(true);
  const [newmodal, setNewModal] = useState(false);
  const [Eventlist, setEventlist] = useState([]);
  const [IsMap, setIsMap] = useState(false);
  const [OrganizerEventlist, setOrganizerEventlist] = useState([]);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const CheckerSeatbook = (sectionIndex, seatIndex, boxid) => {
    return SeatHistorylog.some(seat =>
      seat.boxindex === sectionIndex.toString() &&
      seat.seatindex === seatIndex &&
      seat.boxid === boxid
    );
  };
  const openModal = (image) => {
    setSelectedImage(image);
    setIsOpen(true);
  };
  const sliderRef = useRef(null);
   // Scroll the slider to the left
   const scrollLeft = () => {
    sliderRef.current.scrollBy({ left: -200, behavior: 'smooth' });
  };

  // Scroll the slider to the right
  const scrollRight = () => {
    sliderRef.current.scrollBy({ left: 200, behavior: 'smooth' });
  };
  const imageBaseUrl = 'https://tixme.co/tixme_storage/storage/app/public/FroKulture/';
  const imageBaseUrltwo = 'https://tixme.co/tixme_storage/storage/app/public/Frokulturetwo/';
  
  const images = Array.from({ length: 9 }, (_, i) => ({
    src: `${imageBaseUrl}${i + 1}.png`,
    alt: `Image ${i + 1}`,
  }));
  const images_two = Array.from({ length: 7 }, (_, i) => ({
    src: `${imageBaseUrltwo}${i + 1}.jpeg`,
    alt: `Image ${i + 1}`,
  }));
  // Close modal
  const closeModal = () => {
    setIsOpen(false);
    setSelectedImage(null);
  };
  const handleSeatSelection = (sectionIndex, seatIndex, boxid) => {
    const seatIdentifier = `${sectionIndex}-${seatIndex}-${boxid}`;
    let updatedSelectedSeats = [];
    if (selectedSeats.includes(seatIdentifier)) {
      // If the seat is already selected, remove it from the array
      updatedSelectedSeats = selectedSeats.filter(seat => seat !== seatIdentifier);
    } else {
      // If the seat is not selected, add it to the array
      updatedSelectedSeats = [...selectedSeats, seatIdentifier];
    }
    setSelectedSeats(updatedSelectedSeats);
    localStorage.setItem('selectedSeats', JSON.stringify(updatedSelectedSeats));
  };
  const fetchOrderDetails = async (orderId) => {
  
    const options = {
      method: 'GET',
      headers: {
        'X-BUSINESS-API-KEY': 'cce92d335dda220bbd6a63a0de31b2c93e70ff31d9ab2ab9be4a41de19a30e03',
      },
    };

    try {
      const response = await fetch(`https://api.hit-pay.com/v1/orders/${orderId}`, options);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
     
      if(data.success === true) {
   
      }
    } catch (error) {
      return false;
    } finally {
        return false;
    }
  };
  useEffect(() => {
    fetchOrderDetails('66b105d2af955f0fac8316af');
    const storedSelectedSeats = localStorage.getItem('selectedSeats');
    if (storedSelectedSeats) {
      setSelectedSeats(JSON.parse(storedSelectedSeats));
    }
  }, []);


  function getCountryFlagImage(country) {
    if (country == "India") {
    } else if (country == "United states") {
    } else if (country == "Singapore") {
    } else {
      return null;
    }
  }

  const [position, setPosition] = useState(null);

  useEffect(() => {
    if (IsMap) {
      // Replace with your desired latitude and longitude or use the browser's geolocation API
      const initialPosition = { lat: parseFloat(Eventdata.lat), lng: parseFloat(Eventdata.Lag) };
      setPosition(initialPosition);
    }
  }, [Eventdata]); // Run this effect only once


  const CopyUrlhandel = async () => {
    await navigator.clipboard.writeText(currentUrl);
    toast.success("Copied");
    setIscopy(true)
  }
  const SaveEvent = async (id) => {
    try {
      if (!Beartoken) {
        toast.error("You need to login first");
        return false;
      }
      const requestData = {
        eventid: id
      }
      fetch(apiurl + "website/save-event", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${Beartoken}`, // Set the Content-Type header to JSON
        },
        body: JSON.stringify(requestData),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success == true) {
            if (data.typestatus == 1) {
              // 1 = not saved
              toast.success("Removed");
              setIssaveEvent(false);
            } else if (data.typestatus == 2) {
              // 2 = saved
              toast.success("saved");
              setIssaveEvent(true);
            } else {
              toast.error("Internal Server Error");
            }
          } else {

          }
        })
        .catch((error) => {
          console.error("Insert error:", error);
        });
    } catch (error) {
      console.error("Login api error:", error);
    }
  }
  const checkfollowOrganizer = async (organizer_id) => {
    try {
      setFollowtypeloader(true)
      const userBeartoken = localStorage.getItem('userauth');
      const requestData = {
        organizerid: organizer_id
      }
      fetch(apiurl + "website/check-follow-organizer", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${userBeartoken}`, // Set the Content-Type header to JSON
        },
        body: JSON.stringify(requestData),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success == true) {
            setFollowtype(true)
          } else {
          }
          setFollowtypeloader(false)
        })
        .catch((error) => {
          console.error("Insert error:", error);
          setFollowtypeloader(false)
        });
    } catch (error) {
      console.error("Login api error:", error);
      setFollowtypeloader(false)
    }
  }
  const checkSaveevent = async (eventid) => {
    try {
      setEventsaveapi(true)
      const userBeartoken = localStorage.getItem('userauth');
      const requestData = {
        eventid: eventid
      }
      fetch(apiurl + "website/check-save-event", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${userBeartoken}`, // Set the Content-Type header to JSON
        },
        body: JSON.stringify(requestData),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success == true) {
            setIssaveEvent(true)
          } else {
            setIssaveEvent(false)
          }
          setEventsaveapi(false)
        })
        .catch((error) => {
          console.error("Insert error:", error);
          setEventsaveapi(false)
        });
    } catch (error) {
      console.error("Login api error:", error);
      setEventsaveapi(false)
    }
  }
  const viewEvent = async (id, name) => {
    const formattedName = eventnameurl(name);
    navigate(`${app_url}event/${id}/${formattedName}`)
    try {
      setApiloader(true)
      setIsMap(false);
      const requestData = {
        id: id
      };
      window.scrollTo(0, 0);
      fetch(apiurl + 'event/view-event-details', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json', // Set the Content-Type header to JSON
        },
        body: JSON.stringify(requestData),
      })
        .then(response => response.json())
        .then(data => {         
          if (data.success == true) {                                    
            setEventdata(data.data);
             setTicketsList(data.data.allprice && data.data.allprice.filter(item => item.isdelete === 0));
            setOrganizerdata(data.organizer)
            setTicketsSelledList(data.orderqtylist)
            if (data.data.organizer_id) {
              fetchOrganizerEvent(data.data.organizer_id, data.data._id);
              checkfollowOrganizer(data.data.organizer_id);
              checkSaveevent(data.data._id);
            }
            setIsMap(true);
            if (data.data) {
              setApiloader(false)
            }
          } else {

          }
        })
        .catch(error => {
          console.error('Insert error:', error);
          setApiloader(false)
        });
    } catch (error) {
      console.error('Api error:', error);
    }
    if (!cartItems || cartItems.length === 0) {
      setAllItemsTotalPrice(0);
      setEventTotalPrice(0);
      return;
    }

    const total = cartItems.reduce((accumulator, currentItem) => {
      return accumulator + currentItem.price * currentItem.quantity;
    }, 0);

    setAllItemsTotalPrice(total);

    // Calculate total price for the current event
    const eventTickets = cartItems.filter((item) => item.eventId === id);
    const eventTotal = eventTickets.reduce((accumulator, currentItem) => {
      return accumulator + currentItem.price * currentItem.quantity;
    }, 0);

    setEventTotalPrice(eventTotal);
  }

  const fetchEvent = async () => {
    try {
      const requestData = {
        limit: 3,
        organizerid: null
      }
      fetch(apiurl + "website/all-events-list", {
        method: "POST",
        headers: {
          "Content-Type": "application/json", // Set the Content-Type header to JSON
        },
        body: JSON.stringify(requestData),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success == true) {
           
            setEventlist(data.data);
          } else {
          }
        })
        .catch((error) => {
          console.error("Insert error:", error);
        });
    } catch (error) {
      console.error("Login api error:", error);
    }
  };
  const fetchData = async () => {
    
    window.scrollTo(0, 0);
    try {
      setApiloader(true)
      setIsMap(false);
      const requestData = {
        id: id
      };
      fetch(apiurl + 'event/view-event-details', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json', // Set the Content-Type header to JSON
        },
        body: JSON.stringify(requestData),
      })
        .then(response => response.json())
        .then(data => {
          if (data.success == true) {
            if(data.data.isdelete == 1){
              window.location.href = "/";
              return false;
            }
            setEventdata(data.data);
            
            setSeatmapHeight(data.data.pageheight ? data.data.pageheight : null);
            setSeatmapWidth(data.data.pageweight ? data.data.pageweight : null);
            if (data.data.seatmapimage) {
              setImage(data.data.seatmapimage && laravel_asset + data.data.seatmapimage);
            }
            setTicketsSelledList(data.orderqtylist)
            setTicketsList(data.data.allprice && data.data.allprice.filter(item => item.isdelete === 0));
            setOrganizerdata(data.organizer)
            if (data.data.organizer_id) {
              checkfollowOrganizer(data.data.organizer_id);
              fetchOrganizerEvent(data.data.organizer_id, data.data._id);
              checkSaveevent(data.data._id)
            }

            if (data.data) {
              setApiloader(false)
            }
            setIsMap(true);
          } else {

          }
        })
        .catch(error => {
          console.error('Insert error:', error);
          setApiloader(false)
        });
    } catch (error) {
      console.error('Api error:', error);
    }
  }
  const fetchOrganizerEvent = async (id, eventid) => {
    try {
      const requestData = {
        limit: 4,
        organizerid: id
      }
      fetch(apiurl + "website/all-events-list", {
        method: "POST",
        headers: {
          "Content-Type": "application/json", // Set the Content-Type header to JSON
        },
        body: JSON.stringify(requestData),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success == true) {
            const list = data.data;
            const updatedList = list.filter(item => item._id !== eventid);
        
            setOrganizerEventlist(updatedList);
          } else {
          }
        })
        .catch((error) => {
          console.error("Insert error:", error);
        });
    } catch (error) {
      console.error("Login api error:", error);
    }
  };
  const getSeatmapData = async () => {
    try {
      const requestData = {
        id: id
      };
      fetch(apiurl + 'event/getseatmap', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json', // Set the Content-Type header to JSON
        },
        body: JSON.stringify(requestData),
      })
        .then(response => response.json())
        .then(data => {
          if (data.success == true) {
            setSeatHistorylog(data.Seatlog);
            if (data.data) {
              const newSections = data.data.map(seat => ({
                _id: seat._id,
                name: seat.sectionname,
                sectionId: seat.sectionId,
                rows: seat.rows,
                seatsPerRow: seat.seatsPerRow,
                ticketPrice: seat.ticketid, // Assuming ticketPrice should be set to ticketid
                position: seat.position,
                seatColor: seat.seatColor,
                rotationAngle: seat.rotationAngle,
                ticketName: seat.ticketdetails ? seat.ticketdetails.name : '',
                ticketCurrentValue: seat.ticketdetails ? seat.ticketdetails.price : 0,
                ticketdetails: seat.ticketdetails
              }));
              setSections(newSections);
            }
            if (data.data) {
              const groupedSections = {};

              // Group data by 'seatColor' and 'ticketid'
              data.data.forEach(seat => {
                const key = `${seat.seatColor}-${seat.ticketid}`;

                if (!groupedSections[key]) {
                  groupedSections[key] = {
                    _id: seat._id,
                    name: seat.sectionname,
                    sectionId: seat.sectionId,
                    rows: seat.rows,
                    seatsPerRow: seat.seatsPerRow,
                    ticketPrice: seat.ticketid, // Assuming ticketPrice should be set to ticketid
                    position: seat.position,
                    seatColor: seat.seatColor,
                    rotationAngle: seat.rotationAngle,
                    ticketName: seat.ticketdetails ? seat.ticketdetails.name : '',
                    ticketCurrentValue: seat.ticketdetails ? seat.ticketdetails.price : 0,
                    ticketdetails: seat.ticketdetails,
                    count: 1 // Initialize count to track number of seats merged
                  };
                } else {
                  groupedSections[key].count += 1; // Increment count
                }
              });

              // Convert the grouped data back to an array
              const filteredSections = Object.values(groupedSections).map(section => ({
                color: section.seatColor,
                ticketCurrentValue: section.ticketCurrentValue,
                ticketDetails: section.ticketdetails,
                count: section.count
              }));

              setColorSeat(filteredSections);
            }

          }
        })
        .catch(error => {
          console.error('Insert error:', error);
        });

    } catch (error) {
      console.error('Api error:', error);
    }
  }
  useEffect(() => {
    fetchData();
    fetchEvent();
    getSeatmapData();

  }, []);
  useEffect(() => {

  }, [Eventlist]);
  const [cartItems, setCartItems] = useState([]);
  const [allItemsTotalPrice, setAllItemsTotalPrice] = useState(0);
  const [eventTotalPrice, setEventTotalPrice] = useState(0);
  const [localQuantities, setLocalQuantities] = useState({});

  const eventId = id; // Assuming Eventdata has _id property

  useEffect(() => {
    // Calculate total price when cart items change
    calculateTotalPrice();
  }, [cartItems]);
  useEffect(() => {
    if (isFirstRender) {
      localStorage.setItem('cart', JSON.stringify({ items: cartItems, quantities: localQuantities }));
    }else{
      const entries = Object.entries(localQuantities);
      if (entries.length > 0) {
        const [firstKey] = entries[0];
        setLocalQuantities({
            ...localQuantities,
            [firstKey]: cartItems.length > 0 ? cartItems[0].quantity : 0,
          });
      }
    }
  }, [cartItems]);
  useEffect(() => {
    // Load cart and local quantities from localStorage when component mounts
    loadCartFromLocalStorage();
  }, [SelectedTicketId]);

  //   const addToCart = (item) => {
  //     // Assuming cartItems is defined somewhere in your component

  //     // Check if the cart has items from a different event
  //     const hasDifferentEventItem = cartItems.some(cartItem => cartItem.eventId !== item.eventId);
  //     console.log(item.eventId);
  //     if (hasDifferentEventItem) {
  //         // Log a message and do not add the item to the cart
  //         console.log("You can only add items from the same event to the cart.");
  //         return; // Exit the function
  //     }

  //     // Rest of your logic for adding items to the cart
  //     if (Eventdata.currencycode === "USD") {
  //         localStorage.setItem('payment_gatway', 'Stripe');
  //     } else if (Eventdata.currencycode === "SGD") {
  //         localStorage.setItem('payment_gatway', 'hitpay');
  //     } else if (Eventdata.currencycode === "INR") {
  //         localStorage.setItem('payment_gatway', 'rezorpay');
  //     }

  //     const existingItem = cartItems.find(cartItem => cartItem.name === item.name && cartItem.eventId === item.eventId);

  //     if (existingItem) {
  //         // Update quantity if item already exists in cart
  //         const updatedCart = cartItems.map(cartItem =>
  //             cartItem.name === item.name && cartItem.eventId === item.eventId ? 
  //             { ...cartItem, quantity: cartItem.quantity + 1 } : cartItem
  //         );
  //         setCartItems(updatedCart);
  //     } else {
  //         // Add new item with quantity 1
  //         setCartItems([...cartItems, { ...item, quantity: 1, eventId: item.eventId }]);
  //     }

  //     // Update local quantity state
  //     setLocalQuantities({
  //         ...localQuantities,
  //         [item.name]: (localQuantities[item.name] || 0) + 1,
  //     });

  //     setIsFirstRender(true);
  // };
  const HandelCategorsearch = (value) => {
    let url = `${app_url}events/?categoryId=${encodeURIComponent(value)}`;
    navigate(url);
  };
  const CountSoldOut = (item) => {
    const totalQuantity = TicketsSelledList.filter((i) => i.ticket_id == item.id)
      .reduce((acc, item) => acc + item.quantity, 0);
    const qty_avl = Number(item.quantity) - Number(totalQuantity);
    if (qty_avl == 0) {
      return false;
    } else {
      return true;
    }
  }
  const addToCart = (item, id) => {
    if(id != '66b31dfeb52b54230b8697aa'){
      if (cartItems.length > 0) {
        const existingItemId = cartItems.find((cartItem) => cartItem.id === item.id);
        if (!existingItemId) {
          return toast.error("You cannot purchase items from different ticket categories");
        }
      }
    }
 
    if (ispreview) {
      return toast.error("This is a preview");
    }

    // If the cart is not empty, check if the item ID exists in the cart
    

  

  
    const totalQuantity = TicketsSelledList.filter((i) => i.ticket_id == item.id)
      .reduce((acc, item) => acc + item.quantity, 0);
    const existingItem = cartItems.find((cartItem) => cartItem.name === item.name);
    const CountQty = Number(item.quantity) - Number(totalQuantity);
    const qty_avl = CountQty > 10 ? 10 : CountQty;
    localStorage.setItem('inside_cart_id', id);
  
    if (qty_avl == 0) {
      return toast.error("Cannot add quantity");
    }
  
    // Set payment gateway and currency symbol based on currency code
    if (Eventdata.currencycode.trim() === "USD") {
      localStorage.setItem('payment_gatway', 'Stripe');
      localStorage.setItem('currency_symble', '$');
    } else if (Eventdata.currencycode.trim() === "SGD") {
      localStorage.setItem('payment_gatway', 'hitpay');
      localStorage.setItem('currency_symble', 'S$');
    } else if (Eventdata.currencycode.trim() === "INR") {
      localStorage.setItem('payment_gatway', 'rezorpay');
      localStorage.setItem('currency_symble', '₹');
    }
  
    localStorage.setItem('cart_insert_id', id);
  
    if (existingItem) {
      // Check if adding one more quantity exceeds the available quantity
      if (existingItem.quantity + 1 <= qty_avl) {
        const updatedCart = cartItems.map((cartItem) =>
          cartItem.id === item.id ? { ...cartItem, quantity: cartItem.quantity + 1 } : cartItem
        );
        setCartItems(updatedCart);
        
        // Update local quantity state
        setLocalQuantities({
          ...localQuantities,
          [item.id]: (localQuantities[item.id] || 0) + 1,
        });
      } else {
        if(CountQty > 10){
          toast.error("Please note: A maximum of 10 tickets can be purchased per transaction. You’re welcome to return and make additional purchases!");
        }else{
          toast.error("Unfortunately, there are only "+CountQty+" tickets left!");
        }
        // Show an alert or message if the quantity exceeds the available quantity
        
      }
    } else {
      setCartItems([...cartItems, { ...item, quantity: 1, eventId, event: Eventdata, ticket: item }]);
  
      // Update local quantity state for the new item
      setLocalQuantities({
        ...localQuantities,
        [item.id]: 1,
      });
    }
  
    setIsFirstRender(true);
  };
  

  const removeFromCart = (Id, quantity) => {
    const updatedCart = cartItems.map((cartItem) =>
      cartItem.id === Id ? { ...cartItem, quantity: cartItem.quantity > 0 ? cartItem.quantity - 1 : 0 } : cartItem
    );

    const filteredCart = updatedCart.filter((cartItem) => cartItem.quantity > 0);
    setCartItems(filteredCart);

    // Update local quantity state
    setLocalQuantities({
      ...localQuantities,
      [Id]: quantity > 0 ? quantity - 1 : 0,
    });
    setIsFirstRender(true)
  };
  const removeSeatmapFromCart = (Id) => {
    const updatedCart = cartItems.map((cartItem) =>
      cartItem.id === Id ? { ...cartItem, quantity: cartItem.quantity > 0 ? cartItem.quantity - 1 : 0 } : cartItem
    );
    const filteredCart = updatedCart.filter((cartItem) => cartItem.quantity > 0);
    setCartItems(filteredCart);
  };

  const calculateTotalPrice = () => {
    if (!cartItems || cartItems.length === 0) {
      setAllItemsTotalPrice(0);
      setEventTotalPrice(0);
      return;
    }

    const total = cartItems.reduce((accumulator, currentItem) => {
      return accumulator + currentItem.price * currentItem.quantity;
    }, 0);

    setAllItemsTotalPrice(total);

    // Calculate total price for the current event
    const eventTickets = cartItems.filter((item) => item.eventId === eventId);
    const eventTotal = eventTickets.reduce((accumulator, currentItem) => {
      return accumulator + currentItem.price * currentItem.quantity;
    }, 0);

    setEventTotalPrice(eventTotal);
    if (eventTotal > 0) {
      setPaynowbtnstatus(true)
    } else {
      setPaynowbtnstatus(true)
    }
  };

  const saveCartToLocalStorage = () => {
    if (ispreview) {
      toast.error("This is a preview");
      return false;
    }
    navigate(app_url + 'cart-details');
  };


  const loadCartFromLocalStorage = () => {
    // Load cart items, local quantities, and eventId from localStorage
    const storedCart = localStorage.getItem('cart');
    const check_same_id = localStorage.getItem('cart_insert_id');
    if (SelectedTicketId) {
      localStorage.removeItem('cart');
      localStorage.removeItem('selectedSeats');
      localStorage.removeItem('cart_insert_id');
      localStorage.removeItem('paymentid_token');
      setCartItems([]);
      setLocalQuantities([]);
    } else {
      if (check_same_id && check_same_id == id) {
        if (storedCart) {
          const { items, quantities } = JSON.parse(storedCart);
          // Check if items and quantities exist in the stored data
          if (items && quantities) {
            setCartItems(items);
            setLocalQuantities(quantities);
          }
        }
      } else {
        localStorage.removeItem('cart');
        localStorage.removeItem('selectedSeats');
        localStorage.removeItem('cart_insert_id');
      }
    }
  };
  const openGoogleMaps = () => {
    const location = Eventdata.location; // Replace with the location name or coordinates
    const mapsUrl = `https://www.google.com/maps?q=${encodeURIComponent(location)}`;
    window.open(mapsUrl, "_blank");
  };
  const openGoogleMapswithlon = (aaddress) => {
    const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(aaddress)}`;
    window.open(mapsUrl, "_blank");
  };
  const handelTicketselect = (id) => {
    const matchingTickets = TicketsList.filter(ticket => ticket.datetimeid === id && ticket.isdelete === 0);
    setSelectedTicket(matchingTickets); // Set the array of matching tickets
    setSelectedTicketId(id);
    localStorage.removeItem('cart');
    localStorage.removeItem('selectedSeats');
    localStorage.removeItem('cart_insert_id');
  }
  // ticket type date asc
  const compareDatesAndTimes = (a, b) => {
    const dateTimeA = moment(`${a.date} ${a.time}`, 'DD MMM YYYY hh:mm A');
    const dateTimeB = moment(`${b.date} ${b.time}`, 'DD MMM YYYY hh:mm A');
    return dateTimeA - dateTimeB; // For descending order
  };
  const handelOpenSeatmapmodal = () => {
    setseatmapModal(true);
  }
  return (
    <>
      {!Apiloader && (
        <Helmet>
          <title>{Eventdata.display_name}</title>
          <meta name="description" content={Eventdata.event_desc} />
          {/* {Eventdata.thum_image && (
            <>
              <meta property="og:image" content={Eventdata.thum_image} />
              <meta name="twitter:image" content={Eventdata.thum_image} />
            </>
          )} */}
        </Helmet>
      )}
      {" "}
      
      <div className="content-area">
        <Modal isOpen={seatmapModal} toggle={() => setseatmapModal(!seatmapModal)} centered size="xl">
          <ModalHeader toggle={() => setseatmapModal(!seatmapModal)}>Select Event seats
          </ModalHeader>
          <ModalBody>
            <div>
              <div>
                <div className="row">
                  <div className="col-xl-12">
                    <div className="text-center py-2">
                      <span className="main-title">Total Price : {Eventdata && Eventdata.countrysymbol}{eventTotalPrice.toFixed(2)}</span>{" "}
                    </div>
                    <div className="text-center">
                      {Paynowbtnstatus ? (
                        <button onClick={() => saveCartToLocalStorage()} type="button" className="btn theme-bg text-white mt-3 w-100">Pay Now</button>
                      ) : ''}
                    </div>
                  </div>
                </div>
              </div>
              <hr className="my-2"></hr>
              <div className="d-flex">
                {ColorSeat && ColorSeat.map((item, index) => (
                  <div className="setmap_indigator_box m-2">
                    <div style={{ background: item.color }} className="seat-indigator"></div>
                    <p className="mb-0 seatmap-price">${item.ticketCurrentValue ? (Eventdata && Eventdata.countrysymbol) : ''} ${item.ticketCurrentValue ? item.ticketCurrentValue : 'Free'} {item.ticketDetails && item.ticketDetails.cut_priceitem > 0 && (<span className="price-indigat-cuts">${item.ticketCurrentValue ? (Eventdata && Eventdata.countrysymbol) : ''} ${item.ticketDetails.cut_priceitem}</span>)}</p>
                  </div>
                ))}
              </div>
              <hr className="my-2"></hr>
              <div style={{ overflow: 'auto', width: '100%', height: '100%' }}>
                <div
                  style={{
                    width: `${seatmapWidth}px`, // Update this line
                    height: `${seatmapHeight}px`, // Update this line
                    // width: `${seatmapWidth * zoomLevel}px`, // Update this line
                    // height: `${seatmapHeight * zoomLevel}px`, // Update this line
                    backgroundImage: `url(${image})`,
                    backgroundSize: '100% 100%',
                    backgroundRepeat: 'no-repeat',
                    position: 'relative',
                    // transform: `scale(${zoomLevel})`,
                    transformOrigin: 'top left', // Add this line
                  }}
                >
                  {sections.map((section, index) => (
                    <Draggable
                      key={section.name}
                      position={section.position}
                      bounds="parent"
                      disabled={true}
                    >
                      <div
                        style={{
                          width: `${section.seatsPerRow * 20}px`,
                          height: `${section.rows * 20}px`,
                          transformOrigin: 'center',

                        }}
                        id={`tooltip-${index}`}
                      >
                        <div
                          className={`seatmap_box`}
                          style={{
                            // backgroundColor: selectedSection === section.name ? 'lightblue' : '#eee',
                            transform: `rotate(${section.rotationAngle || 0}deg)`,
                          }}
                        >
                          {Array.from({ length: section.rows }).map((_, rowIndex) => (
                            <div key={rowIndex} style={{ display: 'flex' }}>
                              {Array.from({ length: section.seatsPerRow }).map((_, seatIndex) => (
                                <>
                                  {CheckerSeatbook(rowIndex, seatIndex, section._id) ? (
                                    <>
                                      <div
                                        className={`seatmap_seat f`} style={{ backgroundColor: "#eee", cursor: 'no-drop', }}
                                      >
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      {selectedSeats.includes(`${rowIndex}-${seatIndex}-${section._id}`) ? (
                                        <div
                                          onClick={() => {
                                            removeSeatmapFromCart(section.ticketPrice);
                                            handleSeatSelection(rowIndex, seatIndex, section._id);
                                          }}
                                          className={`seatmap_seat dd ${selectedSeats.includes(`${rowIndex}-${seatIndex}-${section._id}`) ? 'seatmap-selected-bg' : ''}`} key={seatIndex} style={{ backgroundColor: section.seatColor, cursor: 'pointer', }}></div>
                                      ) : (
                                        <div
                                          onClick={() => {
                                            addToCart(section.ticketdetails, Eventdata._id);
                                            handleSeatSelection(rowIndex, seatIndex, section._id);
                                          }}
                                          className={`seatmap_seat ${selectedSeats.includes(`${rowIndex}-${seatIndex}-${section._id}`) ? 'seatmap-selected-bg' : ''}`} key={seatIndex} style={{ backgroundColor: section.seatColor, cursor: 'pointer', }}></div>
                                      )
                                      }
                                    </>
                                  )}
                                </>
                              ))}
                            </div>
                          ))}
                          <Tooltip
                            placement="top"
                            isOpen={tooltipOpen === section.sectionId}
                            target={`tooltip-${index}`}
                            toggle={() => setTooltipOpen(tooltipOpen === section.sectionId ? null : section.sectionId)}
                          >
                            <div dangerouslySetInnerHTML={{
                              __html: `Row: ${section.name} <br/> Ticket: ${section.ticketName} <br/> Price: ${section.ticketCurrentValue ? (Eventdata && Eventdata.countrysymbol) : ''} ${section.ticketCurrentValue ? section.ticketCurrentValue : 'Free'}`
                            }} />
                          </Tooltip>


                        </div>
                      </div>
                    </Draggable>
                  ))}
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <Modal isOpen={newmodal} toggle={() => setNewModal(!newmodal)} centered>
          <ModalHeader toggle={() => setNewModal(!newmodal)}>Share this event
          </ModalHeader>
          <ModalBody>
            <div>
              <Row>
                <Col md={12}>
                  <p className="mb-0">Event URL</p>
                  <input onClick={() => CopyUrlhandel()} className="form-control cursor-pointer" disabled value={currentUrl}></input>
                </Col>
                <Col md={12} className="mt-2">
                  {Iscopy ? (
                    <button onClick={() => CopyUrlhandel()} type='button' className="btn theme-bg text-white">Link copied</button>
                  ) : (
                    <button onClick={() => CopyUrlhandel()} type='button' className="btn theme-bg text-white">Copy link</button>
                  )}
                  <span className="ml-3 theme-color">| Share with <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`} target="_blank" rel="noopener noreferrer"><span className="mx-1 cursor-pointer sh-icon"><FaFacebookF /></span></a><a href={`https://api.whatsapp.com/send?text=${encodeURIComponent(currentUrl)}`} target="_blank" rel="noopener noreferrer"><span className="mx-1 cursor-pointer sh-icon"><FaWhatsapp /></span></a></span>
                </Col>
              </Row>
            </div>
          </ModalBody>
        </Modal>
        <HeaderMenu />
        <div className="mx-lg-4 my-lg-3 banner-event bg-primary-color rounded-8 position-relative">
          <MobileMenu />
          {Apiloader ? (
            <div className="xxx-event-page-top-loader">
              <div className="linear-background w-100" style={{ height: '150px' }}> </div>
            </div>
          ) : (
            <>
              <h3 className="eventpage-cat-name text-white animate__animated animate__bounce">
                <span className="cursor-pointer" onClick={() => HandelCategorsearch(Eventdata.category)}>{Eventdata.category_name}</span>
              </h3>
              <h1 className="banner-h banner-h-event-page banner-h-mob-event text-white text-start text-uppercase">{Eventdata.display_name}</h1>
              {screenWidth > 900 ? (
                <div className="py-2 singel-event-page-head-box">
                  <div className="organizer-name-sec px-2 py-2">
                    <div className="d-inline-flex align-items-center border-right event-time-area px-2">
                      <div className="d-inline-block mr-1">
                        <img height={30} width={'auto'} src={dataIcon} alt="" />
                      </div>
                      <div className="d-inline-block">
                        <span className="event-duration d-block">{Eventdata.start_date}</span>
                      </div>
                    </div>
                    <div className="d-inline-flex align-items-center border-right event-time-area px-2">
                      <div className="d-inline-block mr-1">
                        <img height={30} width={'auto'} src={timeIcon} alt="" />
                      </div>
                      <div className="d-inline-block">
                        <span className="event-duration d-block">Event Start Time</span>
                        <span className="text-white event-time d-block">{Eventdata.start_time}</span>
                      </div>
                    </div>
                    <div className={`d-inline-flex align-items-center ${Eventdata.eventtype == 2 && 'border-right'} event-time-area px-2`}>
                     
                      {Eventdata.isendtimeoptional ? (
                        <>
                         <div className="d-inline-block mr-1">
                         <img height={30} width={'auto'} src={hourglassIcon} alt="" />
                       </div>
                <div className="d-inline-block">
                <span className="event-duration d-block">Event Duration</span>
                <span className="text-white event-time d-block">{Eventdata.event_duration}</span>
              </div>
              </>
            ) : (
              <div className="d-inline-block"></div>
            )}

                     


                    </div>
                    {Eventdata.eventtype == 2 && (
                      <div className="d-inline-flex align-items-center">
                        <div className="d-inline-block mr-1">
                          <img height={30} width={'auto'} src={locationIconevent} alt="" />
                        </div>
                        <div className="d-inline-block">
                          <span className="event-duration d-block eventpage-location-name">
                            {Eventdata.location}
                          </span>
                          {/* {Eventdata.Lag && Eventdata.lat ? (
                            <span onClick={() => openGoogleMapswithlon(Eventdata.displayaddress)} className="text-white event-time d-block cursor-pointer py-0">Get direction</span>
                          ) : (
                            <span onClick={openGoogleMaps} className="text-white event-time d-block cursor-pointer py-0">Get direction</span>
                          )} */}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <>
                  <div className="row px-3 py-3 cust-event-css">
                    <div className="col-6 d-flex align-items-center justify-content-start">
                      <div>
                        <div className="d-inline-flex align-items-center event-time-area py-2 date-event-cust">
                          <div className="d-inline-block mr-1">
                            <img height={30} width={'auto'} src={dataIcon} alt="" />
                          </div>
                          <div className="d-inline-block">
                            <span className="event-duration d-block">{Eventdata.start_date}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-6  d-flex align-items-center justify-content-start">
                      <div>
                        <div className="d-inline-flex align-items-centerevent-time-area">
                          <div className="d-inline-block mr-1">
                            <img height={30} width={'auto'} src={timeIcon} alt="" />
                          </div>
                          <div className="d-inline-block">
                            <span className="event-duration d-block">Event Start Time</span>
                            <span className="event-time d-block text-white">{Eventdata.start_time}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {Eventdata.isendtimeoptional ? (
                          <>
                    <div className="col-6  d-flex align-items-center justify-content-start">
                      <div>
                        <div className="d-inline-flex align-items-center event-time-area">
                       
                          <div className="d-inline-block mr-1">
                            <img height={30} width={'auto'} className="" src={hourglassIcon} alt="" />
                          </div>
                          <div className="d-inline-block">
                            <span className="event-duration d-block">Event Duration</span>
                            <span className="event-time d-block  text-white">{Eventdata.event_duration}</span>
                          </div>
                         
           
                        </div>
                      </div>
                    </div>
                    </>
 ) : (
  <div className="d-inline-block"></div>
)}

                    <div className={`d-flex align-items-center justify-content-start ${Eventdata.isendtimeoptional ? 'col-6' : 'col-12'}`}>
                      <div>
                        <div className="d-inline-flex align-items-center">
                          <div className="d-inline-block mr-1">
                            <img height={30} width={'auto'} src={locationIconevent} alt="" />
                          </div>
                          <div className="d-inline-block">
                            <span className="event-duration d-block eventpage-location-name">
                              {Eventdata.displayaddress || Eventdata.location}
                            </span>
                            {/* <span onClick={openGoogleMaps} className="event-time d-block cursor-pointer py-0  text-white">Get direction</span> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
              <div className="row evnt-page-save-shear-box">
                <div className="text-white d-inline-flex  align-items-center justify-content-md-end justify-content-end ml-2">
                  <span className="d-flex align-items-center cursor-pointer" onClick={() => SaveEvent(Eventdata._id)}>
                    <span className="event-pg-icon">
                      {IssaveEvent ? (<FaHeart />) : (<FaRegHeart />)}
                    </span>
                    <span className="event-pg-icon-text">Add to favourites</span>
                  </span>
                  <span className="d-flex align-items-center  cursor-pointer" onClick={() => { setNewModal(!newmodal); setIscopy(false) }}>
                    <span className="event-pg-icon-img">
                      <img src={WhiteShareIcon} alt="" />
                    </span>
                    <span className="event-pg-icon-text">Share event</span>
                  </span>
                </div>
              </div>
              {/* <div className="banner-child-event">
              <img className="mt-2 event-banner" src={Eventdata.banner_image ? Eventdata.banner_image : EventImg} alt="" />
            </div> */}
            </>
          )}
        </div>
        {Apiloader ? (
          <div style={{ margin: '30px 26px' }}>
            <div className="linear-background w-100"> </div>
          </div>
        ) : (
          <div className="my-lg-3 my-md-3 event-view-body">
            <div className="event-desc event-page-margin">
              <Container fluid>
                <Row>
                  <div className="col-md-12 col-12 mb-5">
                    <div className="event-page-banner-1">
                      <img
                        alt=""
                        src={Eventdata.banner_image ? Eventdata.banner_image : EventImg}
                        fetchpriority="high"
                        data-testid="hero-img"
                      />
                    </div>
                  </div>
                  <div className="col-md-12 col-12 mb-5 d-none">
                    <div className="event-hero">
                      {/* style={{ backgroundImage: `url("${Eventdata.banner_image ? Eventdata.banner_image : EventImg}")` }} */}
                      <div
                        className="event-hero__background"

                      ></div>
                      <div className="css-1vu2yqv e1kx2rja0">
                        <div className="css-1tue3c7 e1kx2rja1">
                          <img
                            width="600"
                            height="300"
                            alt="Gangtok: 21 Day- Free Kundalini Inner Energy Awakening Meditation"
                            src={Eventdata.banner_image ? Eventdata.banner_image : EventImg}
                            fetchpriority="high"
                            data-testid="hero-img"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-7 col-lg-8 col-xl-8">
                    <div className="event-vew-page-margin">
                      <div className="desc-sec">
                        <span className="sec-title" style={{ color: '#003B8F' }}>
                          <Fade bottom>Description</Fade>
                        </span>
                        <Fade bottom>
                        <p style={{fontFamily:'system-ui'}} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(Eventdata.event_desc) }} />

                        </Fade>
                      </div>
                      {/* <div className="desc-sec">
                      <span className="sec-title">Map xxx</span>
                    </div> */}

                      {/* {Eventdata.eventtype == 2 && (
                        <div className="event-page-menu-div">
                          <GoogleMap
                            center={position}
                            zoom={15}
                            mapContainerStyle={{ height: '300px', width: '100%' }}
                          >
                            {position && <Marker position={position} />}
                          </GoogleMap>
                        </div>
                      )} */}
                       {Eventdata._id == '673c2d9764c321cec4ca15de' && (
                       <div className="event-page-menu-div">
                       {/* Single Image */}
                       <div style={{ position: 'relative', width: '100%',textAlign:'center'}}>
                         <img
                           src="https://tixme.co/tixme_storage/storage/app/public/AltitudeCoast/1.jpeg"
                           alt="AltitudeCoast"
                           onClick={() => openModal({
                             src: 'https://tixme.co/tixme_storage/storage/app/public/AltitudeCoast/1.jpeg',
                             alt: 'AltitudeCoast'
                           })}
                           style={{
                             width: '300px', // Adjust the size of the image as needed
                             cursor: 'pointer',
                             marginBottom: '10px',
                           }}
                         />
                       </div>
                     
                       {/* Modal to display full image */}
                       <Modal isOpen={modalIsOpen} toggle={closeModal}>
                         <ModalHeader toggle={closeModal}></ModalHeader>
                         <ModalBody>
                           {selectedImage && (
                             <div>
                               <img src={selectedImage.src} alt={selectedImage.alt} style={{ width: '100%' }} />
                             </div>
                           )}
                         </ModalBody>
                       </Modal>
                     </div>
                     
                          )} 
{Eventdata._id == '6771316585c201234c74c40a' && (
                       <div className="event-page-menu-div">
                       {/* Single Image */}
                       <div style={{ position: 'relative', width: '100%',textAlign:'center'}}>
                         <img
                           src="https://tixme.co/tixme_storage/storage/app/public/sensation/1.jpeg"
                           alt="Frokulture-Presents-Belgian-Sensation-DJ-Damalos"
                           onClick={() => openModal({
                             src: 'https://tixme.co/tixme_storage/storage/app/public/sensation/1.jpeg',
                             alt: 'Frokulture-Presents-Belgian-Sensation-DJ-Damalos'
                           })}
                           style={{
                             width: '400px', // Adjust the size of the image as needed
                             cursor: 'pointer',
                             marginBottom: '10px',
                           }}
                         />
                       </div>
                     
                       {/* Modal to display full image */}
                       <Modal isOpen={modalIsOpen} toggle={closeModal}>
                         <ModalHeader toggle={closeModal}></ModalHeader>
                         <ModalBody>
                           {selectedImage && (
                             <div>
                               <img src={selectedImage.src} alt={selectedImage.alt} style={{ width: '100%' }} />
                             </div>
                           )}
                         </ModalBody>
                       </Modal>
                     </div>
                     
                          )} 
                          {Eventdata._id == '68cd19a0054b844e987deec4' && (
                       <div className="event-page-menu-div">
                       {/* Single Image */}
                       <div style={{ position: 'relative', width: '100%',textAlign:'center'}}>
                         <img
                           src="https://tixme.co/tixme_storage/storage/app/public/GaramMasala/1.jpeg"
                           alt="Diwali Ball"
                           onClick={() => openModal({
                             src: 'https://tixme.co/tixme_storage/storage/app/public/GaramMasala/1.jpeg',
                             alt: 'Diwali Ball'
                           })}
                           style={{
                             width: '400px', // Adjust the size of the image as needed
                             cursor: 'pointer',
                             marginBottom: '10px',
                           }}
                         />
                       </div>
                     
                       {/* Modal to display full image */}
                       <Modal isOpen={modalIsOpen} toggle={closeModal}>
                         <ModalHeader toggle={closeModal}></ModalHeader>
                         <ModalBody>
                           {selectedImage && (
                             <div>
                               <img src={selectedImage.src} alt={selectedImage.alt} style={{ width: '100%' }} />
                             </div>
                           )}
                         </ModalBody>
                       </Modal>
                     </div>
                     
                          )} 
{Eventdata._id == '6751540db7c577b3e2f0c69f' && (
                       <div className="event-page-menu-div">
                       {/* Single Image */}
                       <div style={{ position: 'relative', width: '100%',textAlign:'center'}}>
                         <img
                           src="https://tixme.co/tixme_storage/storage/app/public/BOLLYWOODCOUNTDOWN/1.jpg"
                           alt="Diwali Ball"
                           onClick={() => openModal({
                             src: 'https://tixme.co/tixme_storage/storage/app/public/BOLLYWOODCOUNTDOWN/1.jpg',
                             alt: 'Diwali Ball'
                           })}
                           style={{
                             width: '400px', // Adjust the size of the image as needed
                             cursor: 'pointer',
                             marginBottom: '10px',
                           }}
                         />
                       </div>
                     
                       {/* Modal to display full image */}
                       <Modal isOpen={modalIsOpen} toggle={closeModal}>
                         <ModalHeader toggle={closeModal}></ModalHeader>
                         <ModalBody>
                           {selectedImage && (
                             <div>
                               <img src={selectedImage.src} alt={selectedImage.alt} style={{ width: '100%' }} />
                             </div>
                           )}
                         </ModalBody>
                       </Modal>
                     </div>
                     
                          )} 


                         {Eventdata._id == '6710b3c3f0a56ec4b5a58e6e' && (
                       <div className="event-page-menu-div">
                       {/* Single Image */}
                       <div style={{ position: 'relative', width: '100%',textAlign:'center'}}>
                         <img
                           src="https://tixme.co/tixme_storage/storage/app/public/DiwaliBall/1.jpeg"
                           alt="Diwali Ball"
                           onClick={() => openModal({
                             src: 'https://tixme.co/tixme_storage/storage/app/public/DiwaliBall/1.jpeg',
                             alt: 'Diwali Ball'
                           })}
                           style={{
                             width: '300px', // Adjust the size of the image as needed
                             cursor: 'pointer',
                             marginBottom: '10px',
                           }}
                         />
                       </div>
                     
                       {/* Modal to display full image */}
                       <Modal isOpen={modalIsOpen} toggle={closeModal}>
                         <ModalHeader toggle={closeModal}></ModalHeader>
                         <ModalBody>
                           {selectedImage && (
                             <div>
                               <img src={selectedImage.src} alt={selectedImage.alt} style={{ width: '100%' }} />
                             </div>
                           )}
                         </ModalBody>
                       </Modal>
                     </div>
                     
                          )} 
                             {Eventdata._id == '6771316585c201234c74c40a' && (
                        <div className="event-page-menu-div">
                        <div style={{ position: 'relative', width: '100%' }}>

      {/* Left arrow */}
      <button
        style={{
          position: 'absolute',
          top: '50%',
          left: '0',
          transform: 'translateY(-50%)',
          backgroundColor: 'rgba(0,0,0,0.5)',
          border: 'none',
          color: 'white',
          padding: '10px',
          cursor: 'pointer',
          zIndex: 1,
        }}
        onClick={scrollLeft}
      >
        &#10094;
      </button>

      {/* Horizontal Scrollable Image Slider */}
      <div
        className="image-slider"
        ref={sliderRef}
        style={{
          display: 'flex',
          overflowX: 'hidden',
          whiteSpace: 'nowrap',
          scrollBehavior: 'smooth',
          width: '100%',
        }}
      >
        {images_two.map((imagedata, index) => (
          <img
            key={index}
            src={imagedata.src}
            alt={imagedata.alt}
            onClick={() => openModal(imagedata)}
            style={{
              width: '100px',
              marginRight: '10px',
              marginBottom: '10px',
              cursor: 'pointer',
            }}
          />
        ))}
      </div>

      {/* Right arrow */}
      <button
        style={{
          position: 'absolute',
          top: '50%',
          right: '0',
          transform: 'translateY(-50%)',
          backgroundColor: 'rgba(0,0,0,0.5)',
          border: 'none',
          color: 'white',
          padding: '10px',
          cursor: 'pointer',
          zIndex: 1,
        }}
        onClick={scrollRight}
      >
        &#10095;
      </button>

      {/* Modal to display full image */}
      <Modal isOpen={modalIsOpen} toggle={closeModal}>
        <ModalHeader toggle={closeModal}></ModalHeader>
        <ModalBody>
          {selectedImage && (
            <div>
              <img src={selectedImage.src} alt={selectedImage.alt} style={{ width: '100%' }} />
            </div>
          )}
        </ModalBody>
      </Modal>
    </div>

                        </div>
                          )} 
                        {Eventdata._id == '670f68a1370f938066b0b72f' && (
                        <div className="event-page-menu-div">
                        <div style={{ position: 'relative', width: '100%' }}>

      {/* Left arrow */}
      <button
        style={{
          position: 'absolute',
          top: '50%',
          left: '0',
          transform: 'translateY(-50%)',
          backgroundColor: 'rgba(0,0,0,0.5)',
          border: 'none',
          color: 'white',
          padding: '10px',
          cursor: 'pointer',
          zIndex: 1,
        }}
        onClick={scrollLeft}
      >
        &#10094;
      </button>

      {/* Horizontal Scrollable Image Slider */}
      <div
        className="image-slider"
        ref={sliderRef}
        style={{
          display: 'flex',
          overflowX: 'hidden',
          whiteSpace: 'nowrap',
          scrollBehavior: 'smooth',
          width: '100%',
        }}
      >
        {images.map((image, index) => (
          <img
            key={index}
            src={image.src}
            alt={image.alt}
            onClick={() => openModal(image)}
            style={{
              width: '100px',
              marginRight: '10px',
              marginBottom: '10px',
              cursor: 'pointer',
            }}
          />
        ))}
      </div>

      {/* Right arrow */}
      <button
        style={{
          position: 'absolute',
          top: '50%',
          right: '0',
          transform: 'translateY(-50%)',
          backgroundColor: 'rgba(0,0,0,0.5)',
          border: 'none',
          color: 'white',
          padding: '10px',
          cursor: 'pointer',
          zIndex: 1,
        }}
        onClick={scrollRight}
      >
        &#10095;
      </button>

      {/* Modal to display full image */}
      <Modal isOpen={modalIsOpen} toggle={closeModal}>
        <ModalHeader toggle={closeModal}></ModalHeader>
        <ModalBody>
          {selectedImage && (
            <div>
              <img src={selectedImage.src} alt={selectedImage.alt} style={{ width: '100%' }} />
            </div>
          )}
        </ModalBody>
      </Modal>
    </div>

                        </div>
                          )} 
                          {Eventdata._id == '6916bb81babd9a272f6f0607' && (
                             <div className="event-page-menu-div" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                             <iframe 
                               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7375.143168830168!2d103.84366777621334!3d1.2881949953464757!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da190a6f2e7493%3A0xc1acd5b90495f236!2s34%20South%20Bridge%20Rd%2C%20Singapore%20058668!5e1!3m2!1sen!2ssg!4v1750731871794!5m2!1sen!2ssg"
                               width="600" 
                               height="450" 
                               allowfullscreen="" 
                               loading="lazy" 
                               referrerpolicy="no-referrer-when-downgrade"
                               style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                             </iframe>
                           </div>
                      )}
                                {Eventdata._id == '680477fa7333ad06bd059907' && (
                             <div className="event-page-menu-div" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                             <iframe 
                               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.8081634584764!2d103.844737874303!3d1.289331661768776!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da19cd16f35677%3A0x7809aa3f9781b9ea!2sBlu%20Jaz%2C%20Clarke%20Quay%20Central!5e0!3m2!1sen!2ssg!4v1745849806426!5m2!1sen!2ssg"
                               width="600" 
                               height="450" 
                               allowfullscreen="" 
                               loading="lazy" 
                               referrerpolicy="no-referrer-when-downgrade"
                               style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                             </iframe>
                           </div>
                      )}
                          {Eventdata._id == '67f89c031db6717448d39548' && (
                             <div className="event-page-menu-div" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                             <iframe 
                               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.7901626310486!2d103.83714867430292!3d1.3007692617330346!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da19f308c2b15d%3A0x66d2ba6f88bf4603!2sARK11!5e0!3m2!1sen!2ssg!4v1745849767290!5m2!1sen!2ssg"
                               width="600" 
                               height="450" 
                               allowfullscreen="" 
                               loading="lazy" 
                               referrerpolicy="no-referrer-when-downgrade"
                               style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                             </iframe>
                           </div>
                      )}
                          {Eventdata._id == '67db6470fe607b6490c57c3a' && (
                             <div className="event-page-menu-div" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                             <iframe 
                               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15955.164146312662!2d103.83077243802192!3d1.300216285269468!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da19bc920890d5%3A0x73ac67520b46d6c6!2sGR.iD%20(GR.iD%20Singapore)!5e0!3m2!1sen!2ssg!4v1743735722250!5m2!1sen!2ssg"
                               width="600" 
                               height="450" 
                               allowfullscreen="" 
                               loading="lazy" 
                               referrerpolicy="no-referrer-when-downgrade"
                               style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                             </iframe>
                           </div>
                      )}
                      {Eventdata._id == '67f4eaaa2c7abc338a3df48c' && (
                             <div className="event-page-menu-div" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                             <iframe 
                               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.82480010407!2d103.84850229999999!3d1.2786699!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da19553ab1edcd%3A0x87cd6b712175f9!2sTUFF%20CLUB!5e0!3m2!1sen!2ssg!4v1746701650505!5m2!1sen!2ssg"
                               width="600" 
                               height="450" 
                               allowfullscreen="" 
                               loading="lazy" 
                               referrerpolicy="no-referrer-when-downgrade"
                               style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                             </iframe>
                           </div>
                      )}
                        {Eventdata._id == '687338f9e05bc1d5aebb8a7a' && (
                             <div className="event-page-menu-div" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                             <iframe 
                               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.8245771052293!2d103.8105761745866!3d1.2788133987090275!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da1bda61b8c927%3A0x4f5318b5ab8125ce!2sThe%20Alkaff%20Mansion!5e0!3m2!1sen!2ssg!4v1752382653199!5m2!1sen!2ssg"
                               width="600" 
                               height="450" 
                               allowfullscreen="" 
                               loading="lazy" 
                               referrerpolicy="no-referrer-when-downgrade"
                               style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                             </iframe>
                           </div>
                      )}
                      {Eventdata._id == '68708dd7c003daa6efc23db2' && (
                             <div className="event-page-menu-div" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                             <iframe 
                               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.815250151058!2d103.84860887458653!3d1.2848008987029864!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da19ea9745a08b%3A0xf58982a852f90355!2sHighHouse!5e0!3m2!1sen!2ssg!4v1752382749541!5m2!1sen!2ssg"
                               width="600" 
                               height="450" 
                               allowfullscreen="" 
                               loading="lazy" 
                               referrerpolicy="no-referrer-when-downgrade"
                               style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                             </iframe>
                           </div>
                      )}
                      
                       {Eventdata._id == '6863952f55505c4c52b61bd5' && (
                             <div className="event-page-menu-div" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                             <iframe 
                               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7977.714191686384!2d103.81536357458653!3d1.2577148987303164!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da1bfdc5e1404b%3A0x3062eba361bde102!2sAdventure%20Cove%20Waterpark!5e0!3m2!1sen!2ssg!4v1752382834830!5m2!1sen!2ssg"
                               width="600" 
                               height="450" 
                               allowfullscreen="" 
                               loading="lazy" 
                               referrerpolicy="no-referrer-when-downgrade"
                               style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                             </iframe>
                           </div>
                      )}
                      
                       {Eventdata._id == '68522f51bfcdfa37f2f2ad07' && (
                             <div className="event-page-menu-div" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                             <iframe 
                               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7375.143168830168!2d103.84366777621334!3d1.2881949953464757!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da190a6f2e7493%3A0xc1acd5b90495f236!2s34%20South%20Bridge%20Rd%2C%20Singapore%20058668!5e1!3m2!1sen!2ssg!4v1750731871794!5m2!1sen!2ssg"
                               width="600" 
                               height="450" 
                               allowfullscreen="" 
                               loading="lazy" 
                               referrerpolicy="no-referrer-when-downgrade"
                               style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                             </iframe>
                           </div>
                      )}
                        {Eventdata._id == '68a73ab8e2736476444f03d1' && (
                             <div className="event-page-menu-div" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                             <iframe 
                               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7375.143168830168!2d103.84366777621334!3d1.2881949953464757!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da190a6f2e7493%3A0xc1acd5b90495f236!2s34%20South%20Bridge%20Rd%2C%20Singapore%20058668!5e1!3m2!1sen!2ssg!4v1750731871794!5m2!1sen!2ssg"
                               width="600" 
                               height="450" 
                               allowfullscreen="" 
                               loading="lazy" 
                               referrerpolicy="no-referrer-when-downgrade"
                               style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                             </iframe>
                           </div>
                      )}

   {Eventdata._id == '689b5381c48ef7319a9df8b0' && (
                             <div className="event-page-menu-div" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                             <iframe 
                               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.8245687704293!2d103.81057617430305!3d1.2788187618014368!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da1bda61b8c927%3A0x4f5318b5ab8125ce!2sThe%20Alkaff%20Mansion!5e0!3m2!1sen!2ssg!4v1755010914930!5m2!1sen!2ssg"
                               width="600" 
                               height="450" 
                               allowfullscreen="" 
                               loading="lazy" 
                               referrerpolicy="no-referrer-when-downgrade"
                               style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                             </iframe>
                           </div>
                      )}
  {Eventdata._id == '687f09f6bda31b8a11932692' && (
                             <div className="event-page-menu-div" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                             <iframe 
                               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.844062524429!2d103.82136067430307!3d1.266213261840361!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da192c4a622d1f%3A0x383457321b765a8a!2sSKYFALL%20ROOFTOP%20RESTROBAR%20SINGAPORE!5e0!3m2!1sen!2ssg!4v1755011028884!5m2!1sen!2ssg"
                               width="600" 
                               height="450" 
                               allowfullscreen="" 
                               loading="lazy" 
                               referrerpolicy="no-referrer-when-downgrade"
                               style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                             </iframe>
                           </div>
                      )}


                           {Eventdata._id == '685be9b9ee715a62ef5499ec' && (
                             <div className="event-page-menu-div" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                             <iframe 
                               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.8248001112474!2d103.84363137621318!3d1.2786698953808493!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da19553ab1edcd%3A0x87cd6b712175f9!2sTUFF%20CLUB%20%40%20Oxley%20Tower!5e0!3m2!1sen!2ssg!4v1752382784082!5m2!1sen!2ssg"
                               width="600" 
                               height="450" 
                               allowfullscreen="" 
                               loading="lazy" 
                               referrerpolicy="no-referrer-when-downgrade"
                               style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                             </iframe>
                           </div>
                      )}
                          {Eventdata._id == '685a0a8988127f358b1a6ef3' && (
                             <div className="event-page-menu-div" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                             <iframe 
                               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3687.5535235379125!2d103.85634757458658!3d1.300614398687039!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da19b055d9f41d%3A0x63f977ab01c637f!2sBlu%20Jaz%2C%20Bali%20Lane!5e1!3m2!1sen!2ssg!4v1750731769021!5m2!1sen!2ssg"
                               width="600" 
                               height="450" 
                               allowfullscreen="" 
                               loading="lazy" 
                               referrerpolicy="no-referrer-when-downgrade"
                               style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                             </iframe>
                           </div>
                      )}
                               {Eventdata._id == '67ef48980268da8c3e941d16' && (
                             <div className="event-page-menu-div" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                             <iframe 
                               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.823435814876!2d103.84587667430296!3d1.2795475617991712!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da1908f32466ad%3A0xe45f22d3154247b3!2sMoshi%20SkyPool%20Club!5e0!3m2!1sen!2ssg!4v1743735503908!5m2!1sen!2ssg"
                               width="600" 
                               height="450" 
                               allowfullscreen="" 
                               loading="lazy" 
                               referrerpolicy="no-referrer-when-downgrade"
                               style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                             </iframe>
                           </div>
                      )}
                            {Eventdata._id == '67d3e35c6513439a74f9e684' && (
                             <div className="event-page-menu-div" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                             <iframe 
                               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.8193278038484!2d103.846947774303!3d1.2821866617909916!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da19006d9c0c29%3A0x61912a8a9bec4575!2sMDLR!5e0!3m2!1sen!2ssg!4v1743735445598!5m2!1sen!2ssg"
                               width="600" 
                               height="450" 
                               allowfullscreen="" 
                               loading="lazy" 
                               referrerpolicy="no-referrer-when-downgrade"
                               style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                             </iframe>
                           </div>
                      )}
                          
                          {Eventdata._id == '679214e206895b4afea0d5dc' && (
                             <div className="event-page-menu-div" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                             <iframe 
                               src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d14012.629170007625!2d103.83957568812018!3d1.2819132522092116!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1s33%20PEKIN%20STREET%20%2301-01%2C%20FAR%20EAST%20SQUARE%20SINGAPORE%20048763!5e0!3m2!1sen!2sin!4v1737641317463!5m2!1sen!2sin"
                               width="600" 
                               height="450" 
                               allowfullscreen="" 
                               loading="lazy" 
                               referrerpolicy="no-referrer-when-downgrade"
                               style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                             </iframe>
                           </div>
                      )}
                      {Eventdata._id == '67a4db13348c7c3180c64ddf' && (
                             <div className="event-page-menu-div" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                             <iframe 
                               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4949.631335802766!2d103.8401550758476!3d1.3008748617294892!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da193a77f03d9d%3A0xc8aa01b2f1d9b9c0!2sDrip%20Singapore!5e1!3m2!1sen!2ssg!4v1738914370518!5m2!1sen!2ssg"
                               width="600" 
                               height="450" 
                               allowfullscreen="" 
                               loading="lazy" 
                               referrerpolicy="no-referrer-when-downgrade"
                               style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                             </iframe>
                           </div>
                      )}

                      {Eventdata._id == '67a993ce3d15038a5ee35d4d' && (
                             <div className="event-page-menu-div" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                             <iframe 
                               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d127638.26567070874!2d103.73999484447431!3d1.359151709315594!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da198c862ff8a5%3A0x56f8349c0fd2566d!2sHard%20Rock%20Cafe!5e0!3m2!1sen!2ssg!4v1739170913725!5m2!1sen!2ssg"
                               width="600" 
                               height="450" 
                               allowfullscreen="" 
                               loading="lazy" 
                               referrerpolicy="no-referrer-when-downgrade"
                               style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                             </iframe>
                           </div>
                      )}
                         {Eventdata._id == '6927e9cd2ee5deb4f7f6fb0d' && (
                             <div className="event-page-menu-div" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                             <iframe 
                               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.810656867009!2d103.84439248386163!3d1.2877393584383856!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da1907ee5fd28f%3A0x9e19028adc5c8f1a!2sHigher%20Ground!5e0!3m2!1sen!2ssg!4v1764311418724!5m2!1sen!2ssg"
                               width="600" 
                               height="450" 
                               allowfullscreen="" 
                               loading="lazy" 
                               referrerpolicy="no-referrer-when-downgrade"
                               style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                             </iframe>
                           </div>
                      )}
                      {Eventdata._id == '6927ef5b3c16e1c3871232bc' && (
                             <div className="event-page-menu-div" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                             <iframe 
                               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.7933004486226!2d103.85352167571246!3d1.298782761736321!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da1906effe7205%3A0xbb06415bd2cadbe5!2sClub%20Evo%20Singapore!5e0!3m2!1sen!2ssg!4v1764311372727!5m2!1sen!2ssg"
                               width="600" 
                               height="450" 
                               allowfullscreen="" 
                               loading="lazy" 
                               referrerpolicy="no-referrer-when-downgrade"
                               style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                             </iframe>
                           </div>
                      )}
                       {Eventdata._id == '697439bf7bc435126a44ddd9' && (
                             <div className="event-page-menu-div" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                             <iframe 
                               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7977.724500272337!2d103.81128517401712!3d1.2543381618773854!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da1b9e7cf6eb1b%3A0x54326e52779f2cd4!2sTipsy%20Unicorn!5e0!3m2!1sen!2ssg!4v1769225816788!5m2!1sen!2ssg"
                               width="600" 
                               height="450" 
                               allowfullscreen="" 
                               loading="lazy" 
                               referrerpolicy="no-referrer-when-downgrade"
                               style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                             </iframe>
                           </div>
                      )}  
                       {Eventdata._id == '692a89a0b42fcfc3559caec4' && (
                             <div className="event-page-menu-div" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                             <iframe 
                               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.81491979451!2d103.84841487401705!3d1.2850124617828103!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da194d9414b1d7%3A0x603be86b4d10c686!2sNOVA!5e0!3m2!1sen!2ssg!4v1764396140094!5m2!1sen!2ssg"
                               width="600" 
                               height="450" 
                               allowfullscreen="" 
                               loading="lazy" 
                               referrerpolicy="no-referrer-when-downgrade"
                               style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                             </iframe>
                           </div>
                      )}
                             {Eventdata._id == '6771316585c201234c74c40a' && (
                             <div className="event-page-menu-div" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                             <iframe 
                               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.8070034775196!2d103.84228207396326!3d1.290071761767179!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da19ff85896b37%3A0xa1605bd931e72fac!2sPulse%20Singapore!5e0!3m2!1sen!2sin!4v1735822551322!5m2!1sen!2sin"
                               width="600" 
                               height="450" 
                               allowfullscreen="" 
                               loading="lazy" 
                               referrerpolicy="no-referrer-when-downgrade"
                               style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                             </iframe>
                           </div>
                      )}
                      {Eventdata._id == '677a05f06bce41a311281b3b' && (
                             <div className="event-page-menu-div" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                             <iframe 
                               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3495.4133349239796!2d103.84632347430302!3d1.2802459617970106!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da1992c29d53fd%3A0x75cf17add2a6c232!2sCherry%20Discotheque!5e1!3m2!1sen!2ssg!4v1736052209133!5m2!1sen!2ssg"
                               width="600" 
                               height="450" 
                               allowfullscreen="" 
                               loading="lazy" 
                               referrerpolicy="no-referrer-when-downgrade"
                               style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                             </iframe>
                           </div>
                      )}
                      
                          {Eventdata._id == '6751540db7c577b3e2f0c69f' && (
                             <div className="event-page-menu-div" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                             <iframe 
                               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4949.7252529489915!2d103.81958407584767!3d1.2520852618804719!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da19554d7716ef%3A0xbf8a2f529ec7307e!2sAmara%20Sanctuary%20Sentosa!5e1!3m2!1sen!2ssg!4v1733390503030!5m2!1sen!2ssg" 
                               width="600" 
                               height="450" 
                               allowfullscreen="" 
                               loading="lazy" 
                               referrerpolicy="no-referrer-when-downgrade"
                               style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                             </iframe>
                           </div>
                      )}
                              {Eventdata._id == '674b0e4e307471d2e4c8f3ea' && (
                             <div className="event-page-menu-div" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                             <iframe 
                               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3495.4152796647095!2d103.810576174303!3d1.2788187618014368!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da1bda61b8c927%3A0x4f5318b5ab8125ce!2sThe%20Alkaff%20Mansion!5e1!3m2!1sen!2ssg!4v1732863097592!5m2!1sen!2ssg" 
                               width="600" 
                               height="450" 
                               allowfullscreen="" 
                               loading="lazy" 
                               referrerpolicy="no-referrer-when-downgrade"
                               style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                             </iframe>
                           </div>
                      )}
                          
                          {Eventdata._id == '67482d09d144db70de3255d2' && (
                             <div className="event-page-menu-div" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                             <iframe 
                               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3495.4152796647095!2d103.810576174303!3d1.2788187618014368!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da1bda61b8c927%3A0x4f5318b5ab8125ce!2sThe%20Alkaff%20Mansion!5e1!3m2!1sen!2ssg!4v1732863097592!5m2!1sen!2ssg" 
                               width="600" 
                               height="450" 
                               allowfullscreen="" 
                               loading="lazy" 
                               referrerpolicy="no-referrer-when-downgrade"
                               style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                             </iframe>
                           </div>
                      )} 
                          {Eventdata._id == '6710b3c3f0a56ec4b5a58e6e' && (
                             <div className="event-page-menu-div" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                             <iframe 
                               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4773.084260417432!2d103.84067457571253!3d1.2794900617964375!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da1918fbc69ddf%3A0xf4fcc54d80437d88!2sBehind%20The%20Green%20Door%20SG!5e1!3m2!1sen!2ssg!4v1729152667593!5m2!1sen!2ssg" 
                               width="600" 
                               height="450" 
                               allowfullscreen="" 
                               loading="lazy" 
                               referrerpolicy="no-referrer-when-downgrade"
                               style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                             </iframe>
                           </div>
                      )} 
                         {Eventdata._id == '68ded26a77071a6fffe2d1ec' && (
                             <div className="event-page-menu-div" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                             <iframe 
                               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.8245771032225!2d103.8131511!3d1.2788134000000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da1bda61b8c927%3A0x4f5318b5ab8125ce!2sThe%20Alkaff%20Mansion!5e0!3m2!1sen!2sin!4v1759476436193!5m2!1sen!2sin" 
                               width="600" 
                               height="450" 
                               allowfullscreen="" 
                               loading="lazy" 
                               referrerpolicy="no-referrer-when-downgrade"
                               style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                             </iframe>
                           </div>
                      )}
                {Eventdata._id == '68d63860eecd37879bd9c7c6' && (
                             <div className="event-page-menu-div" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                             <iframe 
                               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7375.143168830168!2d103.84366777621334!3d1.2881949953464757!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da190a6f2e7493%3A0xc1acd5b90495f236!2s34%20South%20Bridge%20Rd%2C%20Singapore%20058668!5e1!3m2!1sen!2ssg!4v1750731871794!5m2!1sen!2ssg" 
                               width="600" 
                               height="450" 
                               allowfullscreen="" 
                               loading="lazy" 
                               referrerpolicy="no-referrer-when-downgrade"
                               style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                             </iframe>
                           </div>
                      )} 
                      {Eventdata._id == '66f68a41de86801c8ba1e405' && (
                             <div className="event-page-menu-div" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                             <iframe 
                               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.7822230836637!2d103.82554417584753!3d1.3057821617140868!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da198c862ff8a5%3A0x56f8349c0fd2566d!2sHard%20Rock%20Cafe!5e0!3m2!1sen!2ssg!4v1727941568145!5m2!1sen!2ssg" 
                               width="600" 
                               height="450" 
                               allowfullscreen="" 
                               loading="lazy" 
                               referrerpolicy="no-referrer-when-downgrade"
                               style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                             </iframe>
                           </div>
                      )} 
                           {Eventdata._id == '68cd19a0054b844e987deec4' && (
                             <div className="event-page-menu-div" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                             <iframe 
                               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.8235252249224!2d103.84067457430297!3d1.2794900617993636!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da1918fbc69ddf%3A0xf4fcc54d80437d88!2sBehind%20The%20Green%20Door%20SG!5e0!3m2!1sen!2ssg!4v1758277877625!5m2!1sen!2ssg" 
                               width="600" 
                               height="450" 
                               allowfullscreen="" 
                               loading="lazy" 
                               referrerpolicy="no-referrer-when-downgrade"
                               style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                             </iframe>
                           </div>
                      )}
                      {Eventdata._id == '673c2d9764c321cec4ca15de' && (
                             <div className="event-page-menu-div" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                             <iframe 
                               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4949.725551070707!2d103.81740777584761!3d1.251927361880939!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da1d0664ba9c39%3A0x5a79e20f13e1cb17!2s1-Altitude%20Coast!5e1!3m2!1sen!2ssg!4v1731998468174!5m2!1sen!2ssg" 
                               width="600" 
                               height="450" 
                               allowfullscreen="" 
                               loading="lazy" 
                               referrerpolicy="no-referrer-when-downgrade"
                               style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                             </iframe>
                           </div>
                      )}
                       {Eventdata._id == '6708eff183e35e9695ee7a4b' && (
                             <div className="event-page-menu-div" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                             <iframe 
                               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.8245687704343!2d103.81057617571255!3d1.2788187617985107!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da1bda61b8c927%3A0x4f5318b5ab8125ce!2sThe%20Alkaff%20Mansion!5e0!3m2!1sen!2ssg!4v1728639157283!5m2!1sen!2ssg" 
                               width="600" 
                               height="450" 
                               allowfullscreen="" 
                               loading="lazy" 
                               referrerpolicy="no-referrer-when-downgrade"
                               style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                             </iframe>
                           </div>
                      )} 
                {Eventdata._id == '66eeb35cf1810a3ed539ceab' && (
                             <div className="event-page-menu-div" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                             <iframe 
                               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.8195661940454!2d103.84271167584758!3d1.2820336617882486!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da19d3eddcbc87%3A0x20c09d171284f94!2sMortar%20%26%20Pestle!5e0!3m2!1sen!2ssg!4v1727941545024!5m2!1sen!2ssg" 
                               width="600" 
                               height="450" 
                               allowfullscreen="" 
                               loading="lazy" 
                               referrerpolicy="no-referrer-when-downgrade"
                               style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                             </iframe>
                           </div>
                      )} 
                       {Eventdata._id == '66fe5ac52f7d9f5e1151daef' && (
                             <div className="event-page-menu-div" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                             <iframe 
                               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.8321535145!2d103.84189217584758!3d1.273928961813356!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da19f80295a7fb%3A0x255dc8273cb0675e!2sMoon%20Rooftop%20Bar%20%26%20Lounge%20Pte.%20Ltd.!5e0!3m2!1sen!2ssg!4v1727946068723!5m2!1sen!2ssg" 
                               width="600" 
                               height="450" 
                               allowfullscreen="" 
                               loading="lazy" 
                               referrerpolicy="no-referrer-when-downgrade"
                               style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                             </iframe>
                           </div>
                      )} 
                          {Eventdata._id == '670f68a1370f938066b0b72f' && (
                             <div className="event-page-menu-div" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                             <iframe 
                               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.807003477526!2d103.8422820758476!3d1.2900717617632496!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da19ff85896b37%3A0xa1605bd931e72fac!2sPulse%20Singapore!5e0!3m2!1sen!2ssg!4v1729067611748!5m2!1sen!2ssg" 
                               width="600" 
                               height="450" 
                               allowfullscreen="" 
                               loading="lazy" 
                               referrerpolicy="no-referrer-when-downgrade"
                               style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                             </iframe>
                           </div>
                      )} 
                      
                      {Eventdata._id == '670ccfb65a41090084bced4c' && (
                             <div className="event-page-menu-div" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                             <iframe 
                               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.8276387093733!2d103.84284947430304!3d1.2768418618075612!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da198e352cc52d%3A0xbdfe908551f2ad78!2sWallich%20Manor!5e0!3m2!1sen!2ssg!4v1728895153880!5m2!1sen!2ssg" 
                               width="600" 
                               height="450" 
                               allowfullscreen="" 
                               loading="lazy" 
                               referrerpolicy="no-referrer-when-downgrade"
                               style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                             </iframe>
                           </div>
                      )} 


                      <Row className="d-none">
                        <Col md={12}>
                          <Slide bottom>
                            <div className="start-in-box eventpage-box-style-event-view mb-5">
                              <Row>
                                <Col md={6}>
                                  <div className="right-box-title">
                                    <p>Tags</p>
                                  </div>
                                </Col>
                                <Col md={12}>
                                  <div className="tags py-2">
                                    <ul className="p-0">
                                      {Eventdata.tags.map((item, index) => (
                                        <li className="d-inline-block m-1 mb-3">
                                          <span className="event-category-title event-category-title-mobile font-13">
                                            {item}
                                          </span>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </Slide>
                        </Col>
                      </Row>

                    </div>
                  </div>
                  <div className="col-12 col-md-5 col-lg-4 col-xl-4">
                  {Eventdata.start_mindate && Eventdata.is_clock_countdown && Eventdata.start_time ? (
  <CoundownDiv 
    date={Eventdata.start_mindate} 
    time={Eventdata.start_time} 
    Eventdatatimezone={Eventdata.timezone}
  />
) : ''}
                    {Eventdata.seatmap ? (
                      <>
                        <div className="start-in-box eventpage-box-style-event-view mb-5 my-5 event-page-ticket" style={{ position: 'relative' }}>
                          <div className={`right-box-title`}>
                            <div className="row border-bottom-1">
                              <div className="col-6 d-flex justify-content-start">
                                <span><Flip left cascade>Tickets</Flip></span>
                              </div>
                              {Eventdata.is_selling_fast && !Eventdata.is_soldout && (
                                <div className="col-6 d-flex justify-content-end">
                                  <span className="selling-f-box text-uppercase">Selling Fast</span>
                                </div>
                              )}
                            </div>
                          </div>
                          {Eventdata.is_soldout ? (
                            <>
                              <button type="button" className="my-2 btn w-100 theme-bg text-white text-uppercase cusrsor-default">sold out</button>
                            </>
                          ) : (
                            <>
                              <div className="row">
                                <button onClick={() => handelOpenSeatmapmodal()} type="button" className="btn theme-bg text-white mt-3 w-100">Select Seats</button>
                              </div>
                            </>
                          )}
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="start-in-box eventpage-box-style-event-view mb-5 my-5 event-page-ticket" style={{ position: 'relative' }}>
                          <div className={`right-box-title`}>
                            <div className="row border-bottom-1">
                              <div className="col-6 d-flex justify-content-start">
                                <span><Flip left cascade>Tickets</Flip></span>
                              </div>
                              {Eventdata.is_selling_fast && !Eventdata.is_soldout && (
                                <div className="col-6 d-flex justify-content-end">
                                  <span className="selling-f-box text-uppercase">Selling Fast</span>
                                </div>
                              )}
                            </div>
                          </div>
                          {Eventdata.is_soldout ? (
                            <>
                              <button type="button" className="my-2 btn w-100 theme-bg text-white text-uppercase cusrsor-default">sold out</button>
                            </>
                          ) : (
                            <>
                              {Eventdata.event_subtype_id == 2 ? (
                                <>
                                  <div className="row">
                                    {Eventdata.allprice ? (
                                      <>
                                        {Eventdata.event_dates.sort(compareDatesAndTimes).map((items, index) => (
                                          <>
                                            {items.is_delete === 0 && (
                                              <>
                                                <div className="col-12 my-3">
                                                  <div className="mx-2">
                                                    <div className={`row new-week-ticket-box ${SelectedTicketId == items.id && 'new-week-ticket-box-active'}`} onClick={() => handelTicketselect(items.id)}>
                                                      <div className="col-6  d-flex align-items-end">
                                                        <div className="d-flex align-items-center">
                                                          <div className="day-box-1">
                                                            <p className="day-name-1">{getDay(items.date)}</p>
                                                          </div>
                                                          <div>
                                                            <p className="week-name-1">{getDayName(items.date)}</p>
                                                            <p className="month-name-1">{getMonthName(items.date)}</p>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div className="col-6 text-end d-flex align-items-end justify-content-end">
                                                        <p className="time-name-1">{items.time}</p>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </>
                                            )}
                                          </>
                                        ))}
                                        {selectedTicket && (
                                          <>
                                            {selectedTicket.map((item) => (
                                              <>
                                                {CountSoldOut(item) && !item.issoldout && !item.issoldout ? (
                                                  <div className="col-12">
                                                    <div className="row my-3">
                                                      <div className="col-6 justify-content-center">
                                                        <p className="mb-0  event_page_price_title">{item.isselling && !item.issoldout ? (<span className="sellingf-text">SELLING FAST</span>) : 'Ticket Type'}</p>
                                                        <div className="grediant-border-in-ticket text-center"><p className="mb-0" style={{ fontSize: '12px' }}>{item.name}</p></div>
                                                      </div>
                                                      <div className="col-6 d-flex justify-content-center">
                                                        <div className="d-inline-block">
                                                          <div className="text-center">
                                                            <p className="mb-0  event_page_price_title">Price : {item.ticket_type == 1 ? Eventdata.countrysymbol + (item.price % 1 === 0 ? item.price.toFixed(2) : item.price) : 'Free'}{item.cut_price && item.cut_price > 0 && (<span className="cut_ticket_price">{Eventdata.countrysymbol}{item.cut_price}</span>)}</p>
                                                          </div>
                                                          <div className="">
                                                            {item.issoldout ? (
                                                              <>
                                                                <button type="button" className="btn theme-bg btn-sm text-white w-100">SOLD OUT</button>
                                                              </>
                                                            ) : (
                                                              <>
                                                                {CountSoldOut(item) ? (
                                                                  <>
                                                                    <div className="row grediant-border d-flex align-items-center mx-1">
                                                                      <div className="col-4"><span className="new_cart_btn" onClick={() => removeFromCart(item.id, localQuantities[item.id] || 0)}>-</span></div>
                                                                      <div className="col-4"><span>{localQuantities[item.id] || 0}</span></div>
                                                                      <div className="col-4"><span className="new_cart_btn" onClick={() => addToCart(item, Eventdata._id)}>+</span></div>
                                                                    </div>
                                                                  </>
                                                                ) : (
                                                                  <>
                                                                    <button type="button" className="btn  btn-sm theme-bg text-white w-100">{CountSoldOut(item) ? 'SOLD OUT' : 'SELLING FAST'}</button>
                                                                  </>
                                                                )}
                                                              </>
                                                            )}
                                                          </div>
                                                        </div>
                                                      </div>
                                                      {item.description && (
                                                        <div className="col-12 ticket-type-dsc">
                                                          <p>{item.description}</p>
                                                        </div>
                                                      )}
                                                    </div>
                                                  </div>
                                                ) : ''}
                                              </>
                                            ))}
                                          </>
                                        )}
                                      </>
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                </>
                              ) : (
                                <>
                                  {Eventdata.allprice ? (
                                    <>
                                      {Eventdata.allprice.map((items, index) => (
                                        <>
                                          {items.isdelete === 0 && items.tickethide == false && (
                                            <div className="row my-3">
                                              <div className="col-6 justify-content-center">
                                                <p className="mb-0  event_page_price_title">{items.isselling && !items.issoldout ? (<span className="sellingf-text">SELLING FAST</span>) : ''}</p>
                                                <div className="grediant-border-in-ticket text-center"><p className="mb-0" style={{ fontSize: '12px' }}>{items.name}</p></div>
                                              </div>
                                              <div className="col-6 d-flex justify-content-center">
                                                <div className="d-inline-block">
                                                  <div className="text-center">
                                                    <p className="mb-0 event_page_price_title">
                                                      Price : {items.ticket_type == 1 ? Eventdata.countrysymbol + (items.price % 1 === 0 ? items.price.toFixed(2) : items.price) : 'Free'}
                                                      {items.cut_price && items.cut_price > 0 ? (
                                                        <span className="cut_ticket_price">
                                                          {Eventdata.countrysymbol}{items.cut_price}
                                                        </span>
                                                      ) : ''}
                                                    </p>
                                                  </div>
                                                  <div className="">
                                                    {items.issoldout ? (
                                                      <>
                                                        <button type="button" className="btn btn-sm theme-bg text-white w-100">SOLD OUT</button>
                                                      </>
                                                    ) : (
                                                      <>
                                                        {CountSoldOut(items) ? (
                                                          <>
                                                            <div className="row grediant-border d-flex align-items-center mx-1">
                                                              <div className="col-4"><span className="new_cart_btn" onClick={() => removeFromCart(items.id, localQuantities[items.id] || 0)}>-</span></div>
                                                              <div className="col-4"><span>{localQuantities[items.id] || 0}</span></div>
                                                              <div className="col-4"><span className="new_cart_btn" onClick={() => addToCart(items, Eventdata._id)}>+</span></div>
                                                            </div>
                                                          </>
                                                        ) : (
                                                          <>
                                                            <button type="button" className="btn btn-sm theme-bg text-white w-100">{CountSoldOut(items) ? 'SELLING FAST' : 'SOLD OUT'}</button>
                                                          </>
                                                        )}
                                                      </>
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                        </>
                                      ))}
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                </>
                              )}
                            </>
                          )}
                          {Eventdata.is_soldout ? '' : (
                            <>
                              <div className="text-center py-2">
                                <span className="main-title">Total Price : {Eventdata.countrysymbol}{eventTotalPrice.toFixed(2)}</span>{" "}
                              </div>
                              <div className="text-center">
                                {Paynowbtnstatus ? (
                                  <button onClick={() => saveCartToLocalStorage()} type="button" className="btn theme-bg text-white mt-3 w-100">Pay Now</button>
                                ) : ''}
                              </div>
                            </>
                          )}
                        </div>
                      </>
                    )}

                    <OrganizerProfile props={Organizerdata} />
                  </div>
                </Row>
              </Container>
            </div>
            <div className="event-category-section mb-5 in-event-page mt-5">
              <Container fluid className="">
                {OrganizerEventlist.length > 0 && (
                  <Row className="mt-2">
                    <Col md={12}>
                      <h2 className="desc-sec theme-color">More events from this organiser</h2>
                    </Col>
                    <Col md={12}>
                      <Row className="p-1" >
                        {OrganizerEventlist.map((item, index) => (
                          <>
                            <div className="col-xl-3 col-xxl-3 col-md-4 col-12 mb-3" >
                              <div className="bg-white rounded-10 shadow-bottom pb-3 cursor-pointer overflow-hidden mx-3 mx-md-0" onClick={() => viewEvent(item._id, item.name)} style={{ height: '100%' }}>
                                <div style={{ position: 'relative' }}>
                                  <span className="event-category-img">{item.category_name}</span>
                                  {getCountryFlagImage(item.countryname)}
                                  <img className="event-card-img" src={item.thum_image ? item.thum_image : Noimg} alt="" />
                                  <div className="d-flex align-items-center event-date-small-box">
                                    <span className="event-date-small">
                                      <img className="card-icon me-2" src={calendar} alt="" />
                                      <span className="text-primary-color fw-bold me-0 mb-0 mt-md-0">
                                        {onlyDayMonth(item.start_date)}
                                      </span>
                                    </span>
                                  </div>
                                </div>
                                <div className="row px-2 mt-2">
                                  <div className="col-md-7 d-flex align-items-center col-7">
                                    <img className="card-icon-logo me-2" src={item.organizer_logo ? item.organizer_logo : Nouserphoto} alt="" />
                                    <div className="d-flex flex-column align-items-start justify-content-start">
                                      <small className="mb-0 wspace-no" style={{ fontSize: '12px' }}>Originated by</small>
                                      <p className="text-primary-color fw-bold mb-0 mt-n1 event-text-org-name">
                                        {item.organizer_name}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="col-md-5  col-5">
                                    <div className="bg-fade rounded text-center event-cart-price-box">
                                      <span className="text-primary-color fw-bold event-cart-display-price">{item.isfreeticket == 1 ? 'FREE' : item.countrysymbol + item.displayprice + '.00'}</span>
                                      <p className="small fw-bold mb-0 pb-0">Onwards</p>
                                    </div>
                                  </div>
                                </div>
                                <div className="row mt-1">
                                  <div className="col-md-12">
                                    <div className="d-flex align-items-center justify-content-start my-2 mx-2">
                                      <img className="card-icon me-1" src={locationIcon} alt="" />
                                      <p className="text-primary-color fw-bold mb-0 event-cart-location">
                                        {item.city ? item.city + ',' : ''} {item.countryname ? item.countryname : ''}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div className="desc-h ms-3 fw-bold mb-0">{item.display_name}</div>
                              </div>
                            </div>
                          </>
                        ))}
                      </Row>
                    </Col>
                  </Row>
                )}
                <Row className="event-box-mobile">
                  <Col md={12} className="mt-4">
                    <h2 className="desc-sec theme-color">Other events you may like</h2>
                  </Col>
                  {Eventlist.map((item, index) => (
                    <div className="col-xl-3 col-xxl-3 col-md-4 col-12 mb-3" >
                      <div className="bg-white rounded-10 shadow-bottom pb-3 cursor-pointer overflow-hidden mx-3 mx-md-0" onClick={() => viewEvent(item._id, item.name)} style={{ height: '100%' }}>
                        <div style={{ position: 'relative' }}>
                          <span className="event-category-img">{item.category_name}</span>
                          {getCountryFlagImage(item.countryname)}
                          <img className="event-card-img" src={item.thum_image ? item.thum_image : Noimg} alt="" />
                          <div className="d-flex align-items-center event-date-small-box">
                            <span className="event-date-small">
                              <img className="card-icon me-2" src={calendar} alt="" />
                              <span className="text-primary-color fw-bold me-0 mb-0 mt-md-0">
                                {onlyDayMonth(item.start_date)}
                              </span>
                            </span>
                          </div>
                        </div>
                        <div className="row px-2 mt-2">
                          <div className="col-md-7 d-flex align-items-center col-7">
                            <img className="card-icon-logo me-2" src={item.organizer_logo ? item.organizer_logo : Nouserphoto} alt="" />
                            <div className="d-flex flex-column align-items-start justify-content-start">
                              <small className="mb-0 wspace-no" style={{ fontSize: '12px' }}>Originated by</small>
                              <p className="text-primary-color fw-bold mb-0 mt-n1 event-text-org-name">
                                {item.organizer_name}
                              </p>
                            </div>
                          </div>
                          <div className="col-md-5  col-5">
                            <div className="bg-fade rounded text-center event-cart-price-box">
                              <span className="text-primary-color fw-bold event-cart-display-price">{item.isfreeticket == 1 ? 'FREE' : item.countrysymbol + item.displayprice + '.00'}</span>
                              <p className="small fw-bold mb-0 pb-0">Onwards</p>
                            </div>
                          </div>
                        </div>
                        <div className="row mt-1">
                          <div className="col-md-12">
                            <div className="d-flex align-items-center justify-content-start my-2 mx-2">
                              <img className="card-icon me-1" src={locationIcon} alt="" />
                              <p className="text-primary-color fw-bold mb-0 event-cart-location">
                                {item.city ? item.city + ',' : ''} {item.countryname ? item.countryname : ''}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="desc-h ms-3 fw-bold mb-0">{item.display_name}</div>
                      </div>
                    </div>
                  ))}
                </Row>
              </Container>
            </div>
          </div>
        )}
      </div >
      <Footer />
    </>
  );
};
export default Home;